import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/home/index'

// 登录页
import login from '@/components/login/index'

// 数据概览
import dateOverview from '@/components/page-date/index'

// 账号概览
import userPage from '@/components/page-user/index'
import userOverview from '@/components/page-user/user'
import accountAnalysis from '@/components/page-user/account-analysis'
import videoAnalysis from '@/components/page-user/video-analysis'
import clientFromQr from '@/components/page-user/client-from-qr'

// 视频概览
import videoOverview from '@/components/page-video/index'

// GFP2视频概览
import video2Overview from '@/components/page-video2/index'

// GFP2客户概览
import clientOverview from '@/components/page-client/index'

// GFP2调研概览
import inquireOverview from '@/components/page-inquire/index'

// GFP2调研问题概览
import inquireQuestionOverview from '@/components/page-inquire-question/index'

Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Detail',
      redirect: '/home/date',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children: [
        {
          path: 'date',
          name: 'date-overview',
          component: dateOverview
        },
        {
          path: 'user',
          name: 'user-page',
          component: userPage,
          redirect: 'user/index',
          children: [
            {
              path: 'index',
              name: 'user-overview',
              component: userOverview
            },
            {
              path: 'page',
              name: 'userAccountPage',
              component: accountAnalysis
            },
            {
              path: 'video',
              name: 'userVideoAnalysis',
              component: videoAnalysis
            },
            {
              path: 'qr',
              name: 'clientFromQr',
              component: clientFromQr
            }
          ]
        },
        {
          path: 'video',
          name: 'video-overview',
          component: videoOverview
        }
      ]
    },
    {
      path: '/video2',
      name: 'Video2-overview',
      component: video2Overview
    },
    {
      path: '/client',
      name: 'client-overview',
      component: clientOverview
    },
    {
      path: '/inquire',
      name: 'inquire-overview',
      component: inquireOverview
    },
    {
      path: '/inquire-question',
      name: 'inquire-question-overview',
      component: inquireQuestionOverview
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js